export default __webpack_public_path__ + "static/media/weather-storm.86d28e77.webp";